import { Button, CircularProgress } from '@mui/material';
import type { FC } from 'react';

import { ReactComponent as SearchStore } from '../../assets/img_searchstore.svg';
import FormattedMessage from '../FormattedMessage';
import styles from './index.module.scss';
type NotFoundPropsType = {
  retry?: boolean;
  retryFn?: () => Promise<void>;
  loading?: boolean;
};

const NotFound: FC<NotFoundPropsType> = ({ retry = true, retryFn, loading }) => {
  return (
    <div className={styles.notFound}>
      <SearchStore />
      <div className={styles.description}>
        <p>{FormattedMessage('components.NotFound.title')}</p>
        {retry && <p>{FormattedMessage('components.NotFound.notice')}</p>}
      </div>
      {retry && (
        <div className={styles.btnContainer}>
          <Button
            onClick={() => {
              if (retryFn) {
                retryFn();
              }
            }}
            className={loading ? styles.loading : ''}
            disabled={loading}
          >
            {loading && (
              <div className={styles.loading}>
                <CircularProgress size={30} color="primary" />
              </div>
            )}
            {FormattedMessage('storeOrders.retry')}
          </Button>
        </div>
      )}
    </div>
  );
};
export default NotFound;
